/**
 * Создает объект, содержащий отображаемое пользователю значение и значение, которое станет значением поля формы
 *
 * Функция создана для использования в инпутах типа `select`
 *
 * Если маска не передана (null или undefined), то свойство `mask` будет равно value.
 *
 * @param {string} value - Исходное значение, которое будет сохранено.
 * @param {string | undefined} mask - Значение, отображаемое пользователю
 *
 * @returns {Object}
 *
 * @example
 * addMask('-', 'Не владею');
 * // Пользователь будет видеть `Не владею`, а значения поля формы будет `-`
 */
export const addMask = (value, mask = null) => ({ value, mask: mask ?? value });
